import { render, staticRenderFns } from "./Uploading.vue?vue&type=template&id=60d8828e&scoped=true&"
import script from "./Uploading.vue?vue&type=script&lang=js&"
export * from "./Uploading.vue?vue&type=script&lang=js&"
import style0 from "./Uploading.vue?vue&type=style&index=0&id=60d8828e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d8828e",
  null
  
)

export default component.exports